// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"00be6360","484":"d050e7eb","643":"0e02bb73","734":"a484f421","829":"94fbe976"}[chunkId] + ".chunk.js";
};